// import external dependencies
import 'intersection-observer';
import 'objectFitPolyfill';
import 'jquery';
import 'daterangepicker';
import 'tiny-slider';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import archiveOffersData from './routes/archive-offers';
import archiveEventsData from './routes/archive-events';
import templateContactUs from './routes/contact-us';
import templateMeetingsConferences from './routes/contact-us';
import singleCompetitions from './routes/single-competitions';
import singleProduct from './routes/single-product';
import lazyLoad from './util/lazyload';
import smoothScrool from './util/smooth-scroll';
import templateCustomEvents from './routes/custom-events';
import templateHome from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  // Offers archive page
  archiveOffersData,
  archiveEventsData,
  templateContactUs,
  templateHome,
  templateMeetingsConferences,
  singleCompetitions,
  templateCustomEvents,
  singleProduct,
});


// Load Events
jQuery(document).ready(() => routes.loadEvents());

lazyLoad();
smoothScrool();

$('a[href]').each(function(){
  var href = $(this).attr('href');

  if(href.match(/(pdf|jpg|jpeg|png)/)) {
    $(this).attr('target', '_blank');
    return;
  }

  if(href.indexOf('http') !== -1 && href.indexOf(window.location.host) === -1) {
    $(this).attr('target', '_blank');
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js